//
//
//
//
//
//
//
//
//
//

import SearchItemDropdown from '@/components/search/SearchItemDropdown'

export default {
  name: 'LanguagesDropdown',
  components: {
    SearchItemDropdown
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    selectedLanguages: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      languages: []
    }
  },
  computed: {
    selectedLabels () {
      return this.languages.filter(l => l.selected).map(l => l.name).join(', ')
    },
    selectedIds () {
      return this.languages.filter(l => l.selected).map(l => l.id)
    }
  },
  mounted () {
    const storeSelectedLangs = this.selectedLanguages
    const defaultsSelectedLangs = this.$store.getters['util/getCurrentLanguageDefaults']?.map(l => l.id)
    const userSelectedLangs = (this.$auth.user?.languages || []).map(l => l.id)
    const alreadySelected = []

    if (storeSelectedLangs.length) {
      alreadySelected.push(...storeSelectedLangs)
    } else if (userSelectedLangs.length) {
      alreadySelected.push(...userSelectedLangs)
    } else {
      alreadySelected.push(...defaultsSelectedLangs)
    }

    this.$store.getters['util/getEnabledLanguages'].forEach((l) => {
      this.languages.push({
        ...l,
        selected: alreadySelected.includes(l.id)
      })
    })
  },
  methods: {
    selectLanguage (language) {
      const index = this.languages.findIndex(l => l.id === language.id)
      this.languages[index].selected = !this.languages[index].selected
      this.$emit('select', this.languages.filter(l => l.selected).map(l => l.id))
    }
  }
}
